var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm-warp"},[_c('popup-warp',{model:{value:(_vm.isMyPosOnlinePay),callback:function ($$v) {_vm.isMyPosOnlinePay=$$v},expression:"isMyPosOnlinePay"}},[_c('div',{staticClass:"myPos-input"},[_c('div',{ref:"myPOSEmbeddedCheckout",attrs:{"id":"myPOSEmbeddedCheckout"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }